"use client";

import { useEffect } from "react";
import { captureMarketingException } from "@/lib/marketing-analytics-client";

import { StatusPageCard } from "@/components/site/primitives/status-page-card";
import { Button } from "@/components/ui/button";

export default function Error({
  error,
  unstable_retry,
}: {
  error: Error & { digest?: string };
  unstable_retry: () => void;
}) {
  useEffect(() => {
    console.error(error);

    captureMarketingException(error, {
      error_boundary: "page",
      error_source: "error_boundary",
      route_name:
        typeof window !== "undefined" ? window.location.pathname || "/" : "unknown",
      digest: error.digest ?? null,
    });
  }, [error]);

  return (
    <>
      <title>Something went wrong | Cooperly</title>
      <meta name="robots" content="noindex" />
      <StatusPageCard
        eyebrow="Error"
        title="Something broke before this page could finish loading."
        description="The content is still intact, but this request hit an unexpected runtime issue. You can retry safely or go back to the homepage."
        primaryAction={{
          href: "/",
          label: "Return home",
        }}
        secondaryAction={{
          href: "/partner-program",
          label: "Open partner program",
        }}
      >
        <Button type="button" size="lg" variant="outline" onClick={() => unstable_retry()}>
          Retry page
        </Button>
      </StatusPageCard>
    </>
  );
}
